import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { List, Form } from 'semantic-ui-react'

//utils
import queries from '../../../utils/queries'

import TitDer from '../../../components/funcionales/titder';
import EstaSeguro from '../../../components/funcionales/estaseg7btn';


// import general from '../../modulos/general';

//dropdown EMPRESAS
const DetalleEmpNivel1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrEmpresa}</option>
  )
};

const ListaEmp = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrEmpresa" id="miLista" onChange={(ev)=>handleChange(ev)}>
        {/* <option value="">Seleccionar Empresa...</option> */}
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown EMPRESAS

//Lista de mecanismos
const DetallePl = ({elemento, handleClickidLista, idListaP}) => {
  let urlSlcm = 'https://montserratslcm.com/api/laboratorio/'  
  return(
    // <tr className='' onClick={(ev)=>handleClickidLista(ev, elemento)}>
    <tr className=''>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: elemento.idPlanta===idListaP.idPlanta?'#faf5aa':'#faf5aa'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.numeroInflab}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: elemento.idPlanta===idListaP.idPlanta?'#faf5aa':'#faf5aa'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.mecInflab}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: elemento.idPlanta===idListaP.idPlanta?'#faf5aa':'#faf5aa'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrPlanta}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: elemento.idPlanta===idListaP.idPlanta?'#faf5aa':'#faf5aa'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrSeccion}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: elemento.idPlanta===idListaP.idPlanta?'#faf5aa':'#faf5aa'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrEquipo}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: elemento.idPlanta===idListaP.idPlanta?'#faf5aa':'#faf5aa'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrComponente}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: elemento.idPlanta===idListaP.idPlanta?'#faf5aa':'#faf5aa'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrMecanismo}</td>
      <td className='' style={{color: 'black', background: '#faf5aa'}}>
        <a style={{color: 'black'}}
          href={urlSlcm + elemento.nomArchivo}
            target="_blank">
          {elemento.nomArchivo}
        </a>
      </td>
    </tr>
  )
};
// href="#" onclick="window.location.href ='file:///./slcm-client/public/images/documentos/' + elemento.nombreDoc"

const ListaPl = ({list, handleClickidLista, idListaP}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} handleClickidLista={handleClickidLista}
        key={i} idListaP={idListaP}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};
//FIN Lista de mecanismos

class AsocDocInf2 extends React.Component {
  state={listRot: this.props.list, idListaP: [], verRotulo: false, argsDocum: {},
    procBtn: 0, permiteBtn1: true, confirmaAct: false, open: false
  }

  crudBD = async (operacionCRUD, args, i)=>{
    //ACTUALIZAR BD
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });

    //Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        const {data} = await operacionCRUD({
          variables: args
        });
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    //ENVIO PARA ACTUALIZAR BD
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }

    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i], i)
    }
  }

  handleClickidLista = async (ev, idListaP)=>{
    ev.preventDefault()

// console.log(idListaP)
    this.setState({idListaP: idListaP})
  }
  handleChange = (ev)=>{
    const argsDocum = this.state.argsDocum

    argsDocum[ev.target.name] = ev.target.value
    this.setState({argsDocum});
    this.setState({idListaP: {}});
    let argsBuscar = `'estadoInflab': 'FINALIZADO'`

    if(this.state.argsDocum.descrEmpresa){
      argsBuscar += `, 'descrEmpresa': /${this.state.argsDocum.descrEmpresa}/i`
    }          
    if(this.props.argsBuscInf.descrPlanta){
      argsBuscar += `, 'descrPlanta': /${this.props.argsBuscInf.descrPlanta}/i`
    }
    if(this.props.argsBuscInf.descrSeccion){
      argsBuscar += `, 'descrSeccion': /${this.props.argsBuscInf.descrSeccion}/i`
    }
    if(this.props.argsBuscInf.descrEquipo){
      argsBuscar += `, 'descrEquipo': /${this.props.argsBuscInf.descrEquipo}/i`
    }
    if(this.props.argsBuscInf.descrComponente){
      argsBuscar += `, 'descrComponente': /${this.props.argsBuscInf.descrComponente}/i`
    }
    if(this.props.argsBuscInf.descrMecanismo){
      argsBuscar += `, 'descrMecanismo': /${this.props.argsBuscInf.descrMecanismo}/i`
    }
    let argsBuscInf = ""
    if(this.props.argsBuscInf.numDocum){
      argsBuscInf = {tipoqry: `[{$match: {${argsBuscar}}}, {$sort: {numeroInflab: -1}}, {$limit: ${this.props.argsBuscInf.numDocum}}]`}
    }else{
      argsBuscInf = {tipoqry: `[{$match: {${argsBuscar}}}, {$sort: {numeroInflab: -1}}, {$limit: 100}]`}
    }

    this.props.allInflabRtes.refetch(argsBuscInf)

    this.setState({argsBuscInf: this.props.argsBuscInf})
  }
  handleQuestionUpdDel = async (ev, btn) => {
    // console.log(btn, this.state.open, this.state.confirmaAct, ev.target.attributes[0].value, this.state.procBtn)
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct && this.state.procBtn===0){
      // console.log("11")
      this.setState({open: true})
      this.setState({permiteBtn1: btn==="1"?true:false})
    }else{
      // if(btnPress!=="Si"&&btnPress!=="No"){
      // console.log("22")
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true})
      // }
    };
    if(btnPress==="No"){
      // console.log("33")
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true})
    };
    if(btnPress==="Si"){
      // console.log("44")
      this.setState({confirmaAct: true})
      this.setState({open: false})
      this.setState({procBtn: 1})
      this.setState({permiteBtn1: btn==="1"?true:false})
      const myBtn = document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  componentDidUpdate(prevProps){
        if(this.props.argsBuscInf!==this.state.argsBuscInf){
          let argsBuscar = `'estadoInflab': 'FINALIZADO'`

          if(this.state.argsDocum.descrEmpresa){
            argsBuscar += `, 'descrEmpresa': /${this.state.argsDocum.descrEmpresa}/i`
          }          
          if(this.props.argsBuscInf.descrPlanta){
            argsBuscar += `, 'descrPlanta': /${this.props.argsBuscInf.descrPlanta}/i`
          }
          if(this.props.argsBuscInf.descrSeccion){
            argsBuscar += `, 'descrSeccion': /${this.props.argsBuscInf.descrSeccion}/i`
          }
          if(this.props.argsBuscInf.descrEquipo){
            argsBuscar += `, 'descrEquipo': /${this.props.argsBuscInf.descrEquipo}/i`
          }
          if(this.props.argsBuscInf.descrComponente){
            argsBuscar += `, 'descrComponente': /${this.props.argsBuscInf.descrComponente}/i`
          }
          if(this.props.argsBuscInf.descrMecanismo){
            argsBuscar += `, 'descrMecanismo': /${this.props.argsBuscInf.descrMecanismo}/i`
          }
          let argsBuscInf = ""
          if(this.props.argsBuscInf.numDocum){
            argsBuscInf = {tipoqry: `[{$match: {${argsBuscar}}}, {$sort: {numeroInflab: -1}}, {$limit: ${this.props.argsBuscInf.numDocum}}]`}
          }else{
            argsBuscInf = {tipoqry: `[{$match: {${argsBuscar}}}, {$sort: {numeroInflab: -1}}, {$limit: 100}]`}
          }
    
          this.props.allInflabRtes.refetch(argsBuscInf)
    
          this.setState({argsBuscInf: this.props.argsBuscInf})
        }
      }

  render(){
    const {listRot, idListaP, verRotulo, permiteBtn1, confirmaAct, open} = this.state;
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})

    let mensaje1 = "Eliminar documento al reporte "
    let mensajeAsImInf = "Asociar documentos al reporte "
    if(idListaP.mecInflab){
      mensaje1 += idListaP.mecInflab
      mensajeAsImInf += idListaP.mecInflab
    }else{
      mensaje1 += "(Seleccionar...)"
      mensajeAsImInf += "(Seleccionar...)"
    }
    
  let imgIcon1 = "images/archivo_32.png"

  let list = []
  if(this.props.allInflabRtes.allInflabRtes){list = this.props.allInflabRtes.allInflabRtes}
  console.log(this.props.allInflabRtes)
  return (
    <div>
      <List selection>
        {/* <TitDer list={list} textBoton1="Empresas" btnNuevo={a010101!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} /> */}
        <TitDer textBoton1="Documentos asociados" btnNuevo={"NO"} styles={this.props.styles}/>
        {/* list={this.props.list}  */}
        {/* <div> */}
        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <Form name="form1" id="form1" onSubmit={confirmaAct
            ?permiteBtn1
              ?(ev)=>this.props.handleElimAsDocInf(ev, idListaP)
                :()=>{}
            :()=>{}}>         
 
            <div className="ui three column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '40%', paddingLeft: '1.2em'}}>
                  <Form.Field>
                    <ListaEmp styles={this.props.styles} list={this.props.list1}
                      handleChange={this.handleChange} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: '40%', paddingLeft: '1.2em'}}>
                  {idListaP.mecInflab &&
                    <Form.Field>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        {mensajeAsImInf}
                      </label>
                      <input id="img" name="img" type="file" accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" multiple={true} style={estilos} onChange={(ev)=>this.props.handleUpdAsDocInf(ev, idListaP)}></input>
                    </Form.Field>
                  }
                </div>
                <div className="column" style={{width: '20%', paddingTop: '0.3em'}}>
                  {idListaP.mecInflab &&
                    <EstaSeguro mensaje1={mensaje1} imgIcon1={imgIcon1} 
                      open={open}
                      styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "1")}/>
                  }
                </div>
              </div>
            </div>
            <div style={{height: '35em', overflow: 'auto'}}>
              <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                <thead className=''>
                  <tr className=''>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Informe</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Reporte</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Planta</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Sección</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '17%'}}>Equipo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '17%'}}>Componente</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '17%'}}>Mecanismo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Archivo</th>
                  </tr>
                </thead>
                <ListaPl list={list} handleClickidLista={this.handleClickidLista} idListaP={idListaP}/>
              </table>
              <p></p>
            </div>
          </Form>
        </div>
      </List>
    </div>
  )
      }
};

export default compose( 
  graphql(queries.query.allInflabRtes, {name:'allInflabRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
  
  graphql(queries.mutation.fecha, {name:'fecha'}),
)(AsocDocInf2)
